import React from "react";

import Dropdown from "../ui/Dropdown";
import { AiOutlineLayout } from "react-icons/ai";
import LayoutSelector from "./LayoutSelector";
import Button from "../ui/Button";

// Options for insert dropdown
const options = [
  { value: "insert-table", label: "Insert Table" },
  { value: "insert-chart", label: "Insert Chart" },
  { value: "insert-image", label: "Insert Image" },
  { value: "insert-slide", label: "Insert Slide" },
];

function SlideControlsTest({
  onAddChart,
  onAddTable,
  onAddImage,
  onSummarize,
  onAddSlide,
  onEditSlide,
  isLoading,
  onMoveMedia,
  onChangeLayout,
  currentSlide,
  currentSlideIndex,
}) {
  // Check if layout selector should be disabled based on media elements
  function checkDisabledStatusOfLayout(LIMIT = 2) {
    if (
      !currentSlide?.slideDataArray ||
      currentSlide.slideDataArray.length < LIMIT
    ) {
      return true;
    }

    const mediaTypes = currentSlide.slideDataArray.filter(
      (item) =>
        item.type === "image" || item.type === "chart" || item.type === "table"
    );

    return mediaTypes.length < LIMIT;
  }

  // if (currentSlideIndex === 1) {
  //   return <></>;
  // }

  return (
    <div className="py-4 flex gap-2">
      <Button type="outline" disabled={isLoading} onClick={onEditSlide}>
        Edit Slide
      </Button>
      {currentSlideIndex !== 1 && (
        <>
          <Dropdown
            options={options}
            openPosition="top"
            label="Insert"
            useAsPopover
            onChange={(e) => {
              console.info("Insert dropdown selection:", e);
              if (e == "insert-slide") onAddSlide();
              if (e == "insert-chart") onAddChart();
              if (e == "insert-image") onAddImage();
              if (e == "insert-table") onAddTable();
            }}
          />

          {!checkDisabledStatusOfLayout(2) && (
            <LayoutSelector
              options={options}
              openPosition="top"
              disabled={checkDisabledStatusOfLayout(2)}
              selectedLayout={
                ["v9", "v4"].includes(currentSlide?.layout)
                  ? "landscape"
                  : "portrait"
              }
              label={
                <>
                  <AiOutlineLayout /> Layout
                </>
              }
              useAsPopover
              onChange={(e) => {
                console.info("Layout changed to:", e);
                onChangeLayout(e);
              }}
            />
          )}
          {!checkDisabledStatusOfLayout(1) && (
            <Button type="outline" disabled={isLoading} onClick={onMoveMedia}>
              <AiOutlineLayout /> Move Media
            </Button>
          )}
        </>
      )}
    </div>
  );
}

export default SlideControlsTest;
